

function makeFilter(filterList, filterForm) {
    const domElement = filterList;
    const openButton = filterList.querySelector('.js-filter-open');
    const closeButton = filterList.querySelector('.js-filter-close');
    const optionList = filterList.querySelector('.js-filter-options');
    const checkboxes = Array.from(optionList.querySelectorAll('input[type="checkbox"]'));


    function closeDropdown() {
        domElement.classList.remove('c-dropdown--open');
        optionList.classList.add('is-hidden');
        openButton.classList.remove('is-hidden');
        closeButton.classList.add('is-hidden');
    }

    function openDropdown() {
        domElement.classList.add('c-dropdown--open');
        optionList.classList.add('is-hidden');
        openButton.classList.remove('is-hidden');
        closeButton.classList.add('is-hidden');
    }

    function toggleDropdown() {
        domElement.classList.toggle('c-dropdown--open');
        optionList.classList.toggle('is-hidden');
        openButton.classList.toggle('is-hidden');
        closeButton.classList.toggle('is-hidden');
    }

    function clear() {
        checkboxes.forEach((checkbox) => {
            checkbox.checked = false;
        });
    }

    /**
     * private functions:
     */
    function closeIfClickedOutside(event) {
        const isClickInside = domElement.contains(event.target);
        if (!isClickInside) {
            closeDropdown();
        }
    }

    function init() {
        document.body.addEventListener('click', closeIfClickedOutside);

        checkboxes.forEach((checkbox) => {
            checkbox.addEventListener('click', () => {
                filterForm.submit();
            });
        });

        domElement.querySelector('.js-filter-toggle')
            .addEventListener('click', (e) => {
                e.preventDefault();
                toggleDropdown();
            });
    }

    init();

    return {
        openDropdown,
        closeDropdown,
        toggleDropdown,
        clear,
    };
}

const Filters = (function makeFilters() {
    function init() {
        const filterForm = document.getElementById('form_kesearch_pi1');
        const elements = document.querySelectorAll('.js-filter-list');
        const filters = Array.from(elements).map(element => makeFilter(element, filterForm));


        document.addEventListener('keydown', (e) => {
            if (e.keyCode === 27) {
                filters.forEach(filter => filter.closeDropdown());
            }
        });

        Array.from(document.querySelectorAll('.js-clear-filters')).forEach((toggle) => {
            toggle.addEventListener('click', (e) => {
                e.preventDefault();
                filters.forEach(filter => filter.clear());
                filterForm.submit();
            });
        });
    }

    return { init };
}());

export default Filters;
